import * as z from "zod";

export const InventoryGeneralFlatTeamSettingsSchema = z.object({
  "ims/cycleCountVariancePercent": z.number().nullish(),
  "ims/cycleCountVarianceAmount": z.number().nullish(),
});
